<template>
  <v-row align="start" dense justify="start">
    <v-col :class="[$vuetify.rtl ? 'text-end' : 'text-start']" cols="12">
      <v-btn icon @click="to ? $router.push(to) :$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'KurccBackButton',
  props: {
    to: {
      required: false
    }
  }
}
</script>
